// extracted by mini-css-extract-plugin
module.exports = {"divider":"Divider_divider__UkIpI","horizontal":"Divider_horizontal__E2NVl","inset":"Divider_inset__ehc3F","middle":"Divider_middle___cSxU","vertical":"Divider_vertical__6Y1zt"};